import { HStack, Box, Link, Text, Center, VStack } from "@chakra-ui/react";
import { Link as ReachLink } from "react-router-dom";
import { BlogURL, OpenSeaURL, PolygonscanURL, TwitterURL } from "../utils/urls";

export default function Footer({ isHome }) {
    return (
        <Center bg="gray.100" mt="10" py="5" minW="100vw">
            <VStack>
                {!isHome && (
                    <Box>
                        <Link as={ReachLink} to="/">
                            <Text fontSize="sm">[Home]</Text>
                        </Link>
                    </Box>
                )}
                <HStack py="3" fontSize="sm">
                    <Link href={PolygonscanURL} isExternal>
                        Polygonscan
                    </Link>
                    <Text>|</Text>
                    <Link href={OpenSeaURL} isExternal>
                        OpenSea
                    </Link>
                    <Text>|</Text>
                    <Link href={BlogURL} isExternal>
                        Blog
                    </Link>
                    <Text>|</Text>
                    <Link href={TwitterURL} isExternal>
                        Twitter
                    </Link>
                </HStack>
                <Box>
                    <Text fontSize="sm">Copyright (c) 2021 Nawoo</Text>
                </Box>
            </VStack>
        </Center>
    );
}
